<template>
  <v-container class="grey lighten-5" >

    <v-row >
      <v-col cols="12">
        <div class='text-h5'>{{ tituloPagina }}</div>
        <v-divider></v-divider>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12">
        <v-data-table  :headers="headers" :items="lstProvas" :search="search"
          :custom-filter="filterOnlyCapsText" 
          :loading="isLoading">
          <template v-slot:top>
            <v-toolbar flat color="white" >
              <v-col cols="5" class="pa-0">
                <v-text-field v-model="search" prepend-inner-icon="mdi-magnify"
                  label="Pesquisar" single-line hide-details ></v-text-field>
              </v-col>

              <v-spacer></v-spacer>
              
              <v-dialog v-model="dialog" max-width="1000px">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="hidden-sm-and-down" dark color="blue" right 
                    hide-details v-bind="attrs" v-on="on"> novo </v-btn>
                  
                  <v-btn class="hidden-md-and-up" small dark fab color="blue" 
                    right top hide-details  v-bind="attrs" v-on="on">
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </template>
                
                <v-card>
                  <v-card-title>
                    <span class="headline">{{ tituloModal }}</span>
                  </v-card-title>
                  <v-card-text>
                    
                    <v-divider></v-divider>

                    <v-container>
                      <v-row >
                        <v-col cols="6" sm="6" md="6">
                        <v-file-input truncate-length="40" v-model="editedItem.arquivo" hide-details></v-file-input>
                        </v-col>
                        <v-col cols="6" sm="6" md="4">
                          <v-select :items="activeProductList"
                            v-model="editedItem.idResidencia"
                            label="Produto*"
                            item-text="nome"
                            item-value="idResidencia">
                          </v-select>
                        </v-col>
                        <v-col cols="6" sm="6" md="2">
                          <v-text-field v-model="editedItem.ano" label="Ano*" hide-details @keypress="isNumber($event)"></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row >
                        <v-col cols="6" sm="6" md="4">
                          <v-text-field v-model="editedItem.descricao" label="Descrição" hide-details></v-text-field>
                        </v-col>
                        <v-col cols="6" sm="6" md="4">
                          <v-text-field v-model="editedItem.instituicao" label="Instituição*" hide-details></v-text-field>
                        </v-col>
                        
                    
                        <v-col cols="6" sm="6" md="4">
                          <v-text-field v-model="editedItem.complemento" label="Complemento" hide-details placeholder="Ex: Gabarito, prova teórico-pratica..." ></v-text-field>
                        </v-col>
                        
                      </v-row>
                    </v-container>
                  </v-card-text>
                  
                  <v-card-actions>

                    <v-spacer></v-spacer>

                    <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                    <v-btn color="blue darken-1" text @click="save">Salvar</v-btn>

                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>
          
          <template v-slot:[`item.acao`]="{ item }">
            <v-icon small class="mr-2" @click="editItem(item)" >mdi-pencil</v-icon>
            <v-icon small @click="excluirItem(item)" >mdi-delete</v-icon>
          </template>
          
        </v-data-table>
        <delete-dialog :dialog="excluirdialog" @confirmar="confirmarExclusao" @cancelar="cancelarExclusao"></delete-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import headers from '../../components/jsonsHelper/headers.json';
import Prova from '../../models/prova'
import { mapActions, mapState } from 'vuex';
import DeleteDialog from '../../components/shared/DeleteDialog'

export default {
    components: {
      DeleteDialog
    },
    data: () => ({
      tituloPagina: 'Cadastro de provas',
      headers: [],
      search: '',
      dialog: false,
      excluirdialog: false,
      dadosTabela: [],
      editedIndex: -1,
      editedItem: new Prova(),
      defaultItem: new Prova(), 
      itemSelecionado: ''
    }),

    computed: {
      ...mapState('product', ['activeProductList']),
      ...mapState('prova', ['lstProvas', 'isLoading']),
      tituloModal () {
        return this.editedIndex === -1 ? 'Nova prova' : 'Editar prova'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      ...mapActions('product', ['getProductListActive']),
      ...mapActions('prova', ['getProvaList', 'salvar', 'excluirProva']),
      initialize () {
        this.headers = headers.provaHeaders; 
        this.getProductListActive();
        this.getProvaList();
      },

      filterOnlyCapsText (value, search) {
        search = search.toString().toLocaleUpperCase();
        return value != null &&
          search != null &&
          typeof value === 'string' &&
          value.toString().toLocaleUpperCase().indexOf(search) !== -1
      },

      editItem(item) {
        this.editedIndex = this.lstProvas.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
      },

      excluirItem (item) {
        this.excluirdialog = true;
        this.itemSelecionado = item;
      },

      confirmarExclusao(){
        const AWS = require('aws-sdk');

        AWS.config.update(
          {
            accessKeyId: "AKIAUTBRXH4JR2WUCFJW",
                secretAccessKey: "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",
                region: "sa-east-1"
            });
        var s3 = new AWS.S3();
        
        const params = {
            Bucket: "medcof-provas",
            Key: this.itemSelecionado.chaveBucket
          };

          s3.deleteObject(params, function(err) {
              if (err) {
                  throw err;
              }
              console.log(`Prova de concurso deletada do bucket`)
          });
        
        this.excluirProva(this.itemSelecionado.idProva).then((status) => {
          status === 200 && this.getProvaList().then(() => this.close());
        });
        this.excluirdialog = false
      },
      cancelarExclusao(){
        this.excluirdialog = false
      },

      close () {
        this.dialog = false;
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1
      },

      async save () {
        await this.salvaNoBucket();
        const resp = await this.salvar(this.editedItem);
        resp === 200 && this.getProvaList().then(() => this.close());
        this.close();
      },

      async salvaNoBucket(){
        let p = this.activeProductList.find( produto => produto.idResidencia === this.editedItem.idResidencia );
        
        this.editedItem.chaveBucket = p.nome.trim() + '-' + this.editedItem.instituicao.trim() + this.editedItem.ano 
        + (this.editedItem.complemento ? ' - ' + this.editedItem.complemento : '') + '.pdf'
        
        const AWS = require('aws-sdk');

        AWS.config.update(
          {
            accessKeyId: "AKIAUTBRXH4JR2WUCFJW",
                secretAccessKey: "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",
                region: "sa-east-1"
            });
        var s3 = new AWS.S3();

        var reader = new FileReader();
        var key = this.editedItem.chaveBucket;
        reader.readAsArrayBuffer(this.editedItem.arquivo);

        reader.onload = function() {
          const params = {
            Bucket: "medcof-provas",
            Key: key,
            Body: reader.result
          };

          s3.upload(params, function(err, data) {
              if (err) {
                  throw err;
              }
              console.log(`Prova de concurso carregado no bucket. ${data.Location}`)
          });
        }
        
      },
      

      isNumber: function(evt) {
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
          evt.preventDefault();
        } else {
          return true;
        }
      },
    }
  }
</script>